import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const UPLOAD_SINGLE_FILE_CLASS_NAME = 'UploadSingleFile';
export const UPLOAD_SINGLE_FILE_CLASS_SLOTS = ['root'] as const;

export type UploadSingleFileClassSlot =
	(typeof UPLOAD_SINGLE_FILE_CLASS_SLOTS)[number];

export interface UploadSingleFileClasses {
	root: string;
}

export type UploadSingleFileClassKey = keyof UploadSingleFileClasses;

export const getUploadSingleFileUtilityClass = (slot: string) =>
	generateUtilityClass(UPLOAD_SINGLE_FILE_CLASS_NAME, slot);

export const uploadSingleFileClasses: UploadSingleFileClasses =
	generateUtilityClasses(UPLOAD_SINGLE_FILE_CLASS_NAME, ['root']);

export default uploadSingleFileClasses;
